import React from 'react';

// Logo: red dot (x-height sized) + bold Helvetica wordmark. Styles in index.css.
const Wordmark = () => (
  <span className="wordmark">
    <span className="wordmark-dot" />
    sample.band
  </span>
);

export default Wordmark;
